import { render, staticRenderFns } from "./HdsCheckbox.vue?vue&type=template&id=59d3b536&scoped=true&"
import script from "./HdsCheckbox.vue?vue&type=script&lang=ts&"
export * from "./HdsCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./HdsCheckbox.vue?vue&type=style&index=0&id=59d3b536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d3b536",
  null
  
)

export default component.exports